//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sysUsers, sysUsers_del } from '@/apis/system'

export default {
    data() {
        return {
            form: {
                realname: '',
            },
            isLoading: false,
            //table data
            data: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns.push({ title: '登錄名', dataIndex: 'loginUsername', key: 'loginUsername' });
        this.columns.push({ title: '用戶名', dataIndex: 'realname', key: 'realname' });
        this.columns.push({ title: '是否為管理員', width: 130, dataIndex: 'isAdmin', key: 'isAdmin', scopedSlots: { customRender: 'isAdmin' } });
        this.columns.push({ title: '性別', width: 90, dataIndex: 'sex', key: 'sex', scopedSlots: { customRender: 'sex' } });
        this.columns.push({ title: '手機號', dataIndex: 'telphone', key: 'telphone' });
        this.columns.push({ title: '創建時間', dataIndex: 'createdAt', key: 'createdAt' });
        this.columns.push({ title: '狀態', width: 130, dataIndex: 'state', key: 'state', scopedSlots: { customRender: 'state' } });
        this.columns.push({ title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, });
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageLoad(isPostBack) {
            if (this.isLoading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.isLoading = true;
                const res = await sysUsers({
                    ...this.form,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.data = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.isLoading = false;
            }
        },
        /* 頁面事件鉤子 */
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //刪除行
        async handleRowDelete(item) {
            try {
                const res = await sysUsers_del(item.sysUserId);
                if (res.code == 0) {
                    this.onPageLoad();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        handleToInstall() {
            this.$router.push(`/security/account/form`);
        },
        handleToEdit(id) {
            this.$router.push(`/security/account/form/${id}`);
        },
        handleToAccountRole(id){
            this.$router.push(`/security/account/role/${id}`);
        }
    }
}
